import { Box, Card, Button, CardContent, CardMedia, Checkbox,
    Grid,Radio, Typography ,Link} from '@mui/material'
  import React from 'react'
  import { createTheme, ThemeProvider } from '@mui/material/styles';
  import  Slider from '@mui/material/Slider';
//   import { ResultSlider } from './ResultSlider';
  import { SideSlider } from './SideSlider';
  import { styled } from "@mui/material/styles";
  import img from './AllMenuCard.png'
  import TagButton from '../LandingPage1/TagButton/TagButton';
  import GradeIcon from '@mui/icons-material/Grade';
  import TabsBtn from './TabsBtn';
import { useNavigate } from 'react-router';

  
  const theme = createTheme({
      palette:{
          secondary:{
              main: '#2B817B'
          }
      }
  })
  const Sdrawer =styled('div')(({ theme })=>({
      
      [theme.breakpoints.up('md')]:{
          display: 'none'
      },
      [theme.breakpoints.down('md')]:{
          display: 'block'
      }
  }));
const AllMenuFilter = () => {
      
  // -------------------- radio check
      const [selectedValue, setSelectedValue] = React.useState("");
      const [value1, setValue1] = React.useState("");
      const [getDietry, setgetDietry] = React.useState("");
      const [subscription, setSubscription]= React.useState(false)
  
      
      const handleChange1 = (event) => {
          setValue1(event.target.value);
      };
      const handleChange = (event) => {
          setSelectedValue(event.target.value);
      };
      const handleChangeDietry=(event)=>{
          setgetDietry(event.target.value);
      }
      const handleChangesubs=(event)=>{
              setSubscription(event.target.checked);
      }    
      const setDefault = (event) => {
          setValue1(event.target.value);
          setSelectedValue(event.target.value);
          setgetDietry(event.target.value);
          setSubscription(event.target.checked);
      }
      
      const controlProps = (item) => ({
          checked: selectedValue === item,
          onChange: handleChange,
          value: item,
          name: 'size-radio-button-demo',
          inputProps: { 'aria-label': item },
      });
  
      const controlProps1 = (item) => ({
          checked: value1 === item,
          onChange: handleChange1,
          value: item,
          name: 'size-radio-button-demo',
          inputProps: { 'aria-label': item },
      });
      const controlPropsDietry = (item) => ({
          checked: getDietry === item,
          onChange: handleChangeDietry,
          value: item,
          name: 'size-radio-button-demo',
          inputProps: { 'aria-label': item },
      });
      
      
  
  // --------------
      const resetbtn={
          display: 'flex',
          flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      // padding: '14px 48px',
      width: '190px',
      height: '34px',
      background: '#FFFFFF',
      border: '1px solid #559A95',
      color: '#559A95',
      borderRadius: '6px',
      margin: ' 0px auto',
      }
      const inlineStyleRated= {
      
      fontFamily: 'Outfit',
      width: '145px',
      height: '25px',
      left: '0px',
      top: '52px',
      backgroundColor: '#FFFFFF',
          border: '1px solid #E1E1E6',
      borderRadius: '42px 0px 0px 42px',
      
  };
      const inlineStyleRated2= {
      
      fontFamily: 'Outfit',
      width: '139px',
      height: '25px',
      left: '0px',
      top: '52px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #E1E1E6',
      borderRadius: '0px 42px 42px 0px',
  };
  //                -----------------
  
  
  const minDistance = 30;
  const [value, setValue] = React.useState([1, 40]);
  
      const handleChangeSlider = (event, newValue, activeThumb) => {
          if(!Array.isArray(newValue)){
                  return;
          }
          if (activeThumb === 0){
              setValue([Math.min(newValue[0], value[1] - minDistance), value[1]])
          }else{
              setValue([value[0], Math.max(newValue[1], value[0] + minDistance)])
          }
              console.log(value)
      };
      function valuetext(value) {
          return `${value}`;
      }
      console.log(valuetext(null))
      let navigate = useNavigate();
  return (
  <div className='container-lg'>
      {/* <div className='searchTitle'>
          <div>
              <h2 className='font-link'>"Arabian"</h2>
          </div>
          <div>
              <p>260+Result for "arabian"</p>
          </div>
      </div> */}
      <Box sx={{
        mb:'40px',
        mt:'50px',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between'
      }}>
            <Box>
                <Typography sx={{fontWeight:600,fontSize:'40px'}}>All Menu</Typography>
            </Box>
             <Box sx={{display: 'flex', justifyContent: 'space-between' }}>
                <Sdrawer>
                <Box sx={{ display: 'flex', justifyContent: 'space-center' }}>
                    <SideSlider />
                </Box>
                </Sdrawer>
  
            </Box>
      </Box>
       
      <div className='container-lg sResultSepr'>
                <Box sx={{ margin:'15px' }}>
                    <Grid container spacing={2}>
                        <Grid item  md={3.5}  
                        sx={{              
                            display: {lg:'block',md:'block',sm:'none',xs: 'none'},
                            border:'1px solid #e1e1e6',
                            borderRadius:'5px',

                        }}>
                            <form>
                         <Box>
                          <Typography variant="h5" gutterBottom
                                  sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '20px', color: '#1A1824', fontWeight: '600' }}>
                              sort by
                          </Typography>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} style={{marginBottom: '-10px'}}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Best Match
                                  </Typography>
                                  <ThemeProvider theme={theme}>
  
                                  <Radio size="small" defaultChecked={true}
                                      {...controlProps("bestmatch")} name='bestmatch' color="secondary"
                                      />
                                      </ThemeProvider>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Popular
                                  </Typography>
                                   <ThemeProvider theme={theme}>
                                  <Radio size="small"
                                              {...controlProps('popular')}  color="secondary"
                                      />
                                      </ThemeProvider>   
                              </Box>
                                 </Box>   
                         <Box sx={{marginTop: 3}}>
                          <Typography variant="h5" gutterBottom
                                  sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '20px', color: '#1A1824', fontWeight: '600' }}>
                              Order Type
                          </Typography>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} style={{marginBottom: '-10px'}}>
                                  <Typography variant="h4" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Show only business<br/> subscription
                                  </Typography>
                                  <ThemeProvider theme={theme}>
  
                                  <Checkbox size="small" sx={{borderRadius: 2, backgroundColor: 'white'}}
                                          checked={subscription}    onChange={handleChangesubs} inputProps={{ 'aria-label': 'controlled' }}
                                       color="secondary"
                                      />
                                      </ThemeProvider>
                              </Box>
                              
                                 </Box>   
                          
                         <Box sx={{marginTop: 3}}>
                          <Typography variant="h5" gutterBottom
                              sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '600', fontSize: '20px', color: '#1A1824' }}>
                              Resto Settings
                          </Typography>
                              <Box sx={{ display: 'flex', flexDirection:'row',alignItems: 'center' }} >
                                  <Box style={inlineStyleRated}>
                                      {/* <i style={{ color: '#FAA641', }} className="fa-sharp fa-solid fa-star me-1"></i> */}
                                         <Box sx={{
                                            display:'flex',
                                            flexDirection:'row',
                                            alignItems:'center',
                                            justifyContent:'center',
                                         }}>
                                            <Box>
                                                <GradeIcon sx={{color:'#f7972a'}}/>
                                            </Box>
                                            <Box sx={{ml:'5px'}}>
                                                <Typography sx={{textAlign:'center',color:'#545359'}}>Rated 4.0 +</Typography>
                                            </Box> 
                                         </Box>                                           
                                  </Box>
                                  <Box style={inlineStyleRated2}>
                                      {/* <i style={{ color: '#FAA641', }} className="fa-sharp fa-solid fa-star me-1"></i> */}
                                      <Box sx={{
                                            display:'flex',
                                            flexDirection:'row',
                                            alignItems:'center',
                                            justifyContent:'center',
                                         }}>
                                            <Box>
                                                <GradeIcon sx={{color:'#f7972a'}}/>
                                            </Box>
                                            <Box sx={{ml:'5px'}}>
                                                <Typography sx={{textAlign:'center',color:'#545359'}}>Rated 4.0 +</Typography>
                                            </Box> 
                                         </Box>
                                  </Box>
                              </Box>
                              
                                 </Box>   
                          
                         <Box sx={{marginTop: 3}}>
                          <Typography variant="h5" gutterBottom
                              sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '600', fontSize: '20px', color: '#1A1824' }}>
                              Price Range
                          </Typography>
                              <Box sx={{ width: '96%', margin: 'auto' }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                  width: '98%', marginBottom: -1}}>
                                      <Typography variant="" gutterBottom
                                          sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                     <ThemeProvider theme={theme}>
                                      <Radio size="small"
                                          {...controlProps1('monthly')}
                                          name="monthly"
                                           color="secondary" />
                                          </ThemeProvider>
                                               Monthly   
                                      </Typography>
                                      <Typography variant="" gutterBottom
                                          sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      <ThemeProvider theme ={theme} >
                                      <Radio size="small"
                                          {...controlProps1('weekly')}
                                          color="secondary" />
                                          </ThemeProvider>
                                          Weekly
                                      </Typography>
                                  </Box>
                                  <ThemeProvider theme={theme}>
                                  <Slider getAriaLabel={()=> 'price range'} value={value} 
                                  valueLabelDisplay='on' onChange={handleChangeSlider}
                                  getAriaValueText={valuetext} disableSwap color="secondary"
                                  />
                                  </ThemeProvider>
                              </Box>
                              
                                 </Box>   
                          <Box sx={{ marginTop: 3 }}>
                              <Typography variant="" gutterBottom
                                  sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '20px', color: '#1A1824', fontWeight: '600' }}>
                                  Dietary
                              </Typography>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Vegetarian
                                  </Typography>
                                  <ThemeProvider theme={theme}>
                                          <Radio size="small" defaultChecked
                                              {...controlPropsDietry('vegetraian')}
                                      color="secondary" />
                                      </ThemeProvider>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Vegan
                                  </Typography>
                                  <ThemeProvider theme={theme}>
                                  <Radio size="small"
                                              {...controlPropsDietry('vegan')}
                                      color="secondary" />
                                      </ThemeProvider>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Halal
                                  </Typography>
                              <ThemeProvider theme={theme}>
  
                                  <Radio size="small"
                                              {...controlPropsDietry('halal')}
                                      color="secondary" />
                                      </ThemeProvider>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Low-crab
                                  </Typography>
                                  <ThemeProvider theme={theme}>
  
                                  <Radio size="small"
                                              {...controlPropsDietry('low-crab')}
                                      color="secondary" />
                                      </ThemeProvider>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Gluten Friendly
                                  </Typography>
                                  <ThemeProvider theme={theme}>
  
                                  <Radio size="small"
                                              {...controlPropsDietry('gluten')}
                                      color="secondary" />
                                      </ThemeProvider>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Lactose-Free
                                  </Typography>
                                  <ThemeProvider theme={theme}>
  
                                  <Radio size="small"
                                              {...controlPropsDietry('lactodose')}
                                      color="secondary" />
                                      </ThemeProvider>
                              </Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Typography variant="" gutterBottom
                                      sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontSize: '16px', color: '#1A1824' }}>
                                      Dairy-Free
                                  </Typography>
                                  <ThemeProvider theme={theme}>
  
                                  <Radio size="small"
                                              {...controlPropsDietry('dairy')}
                                      color="secondary" />
                                      </ThemeProvider>
                              </Box>
                          </Box>            
                              <Box sx={{
                                display:'flex',
                                flexDirection:'row',
                                justifyContent:'center',
                                alignItems:'center',
                                mb:'30px',
                                mt:'20px'
                              }}>
                                    <Button variant="outlined" size="large" onClick={setDefault} sx={{
                                        width:'80%'
                                    }}>Reset</Button>
                              </Box>
                          </form>
                          
  
                        </Grid>
                      <Grid item md={8.5} sx={{
                          display: { xs: "block" }
                      }} >
                           
                            {/* <Box >
                                    <ResultSlider />
                            </Box> */}
                                      {/* meal section start */}
                            <Box  >
                             <Box>
                                <TabsBtn/>
                             </Box>
  
                              <Box  >
                                  <Grid container spacing={1}>
                                {[1,2,3,4].map(items=>{
                                    return(
                                        <Grid item xs={12}  md={12}  key={items.index} > 
                                                 <Card sx={{
                                                    display: 'flex', 
                                                    flexDirection:{lg:'row',md:'row',sm:'row',xs:'column'},
                                                    height: {lg:158,md:158,sm:158,xs:'auto'},
                                                    cursor:'pointer',
                                                }} onClick={()=> navigate('/Filtered')}>
                                                  <CardMedia
                                                      component="img"
                                                      alt="green iguana"
                                                      height="158" sx={{ width: {lg:280,md:280,sm:280,xs:'auto'}, objectFit: 'cover'}}
                                                      image={img}
                                                  />
                                                  
                                                  <CardContent>
                                                    <Typography variant="caption" sx={{ fontSize: 14, fontFamily: 'Outfit', color: '#559A95', fontStyle: 'normal' }} gutterBottom>
                                                          Arabian Cusine
                                                      </Typography>
                                                    <Typography gutterBottom variant="body1" component="div" sx={{ fontSize: 20, fontFamily: 'Outfit', color: '#1A1824', fontStyle: 'normal' }} >
                                                        Chicken and Broccoli Rice Casserole
                                              </Typography>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <i style={{ color: '#FAA641' }} class="fas-sharp fa-solid fa-star"></i>
                                                        <span style={{ fontSize: 14, fontFamily: 'Outfit', color: '#FAA641', fontStyle: 'normal', marginRight: 9 }}>4.7</span>
                                                        <img alt="" src="./AllMenuCard.png" style={{ width: 40, borderRadius: 10, marginRight: 10, objectFit:'cover' }} />
                                                        <span style={{ fontSize: 14, fontFamily: 'Outfit', color: '#9EA3AE', fontStyle: 'normal' }}>Chef Juna Food </span>
                                                       </Box>
                                                    <Typography variant="body2" style={{ fontSize: 14, fontFamily: 'Outfit', color: '#9EA3AE', fontWeight: 400, fontStyle: 'normal', marginTop: 5 }}>
                                          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry . . . .
                                          </Typography>
                                      </CardContent>
                                      
                                                </Card>
                                   </Grid>
                                    )
                                })}
  
                                  
                                  </Grid>
                                  <Box sx={{
                                    display:'flex',
                                    flexDirection:'row',
                                    justifyContent:'center',
                                    mt:'30px'
                                  }}>
                                        <Link sx={{fontWeight:600,fontSize:'15px'}} href='#'>Learn More</Link>
                                  </Box>
                              </Box>
                            </Box>
                        
                        </Grid>
                    </Grid>
                </Box>
      </div>
  
  
  
  </div>
      )
  }


  export default AllMenuFilter
  
  
  
  {/* <FormControl>
                                                      <RadioGroup 
                                               row
                                              aria-labelledby="demo-controlled-radio-buttons-group"
                                              name="controlled-radio-buttons-group"
                                              value={value1}
                                              onChange={handleChange1}
                                              >
                                              <FormControlLabel value="month" defaultChecked control={<Radio />} label="MONTH" />
                                              <FormControlLabel value="male" control={<Radio />} label="Male" />
                                          </RadioGroup>
                                      </FormControl> */}
  
                                           